export const numberFormat = (num?: number, prefix?: string) => {
  return prefix + (num ?? 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
